import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const TitleContainer = styled.div`
  display: flex;
  gap: 0.35em;
`;

export const TitleLabel = styled.span`
  color: var(--text-default);
`;

export const CountLabel = styled.span`
  color: var(--text-soft);
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-soft);
  }

  &:hover {
    background: var(--surface-hover);
  }
`;

export const StyledFavicon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
  flex-shrink: 0;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const CitationTitle = styled.span`
  ${typographyV2.bodySm};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CitationUrl = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
